import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Button } from '../Button';
import { Icon, IconTypes } from '../Icon';

interface EmptyProps {
  buttonLabel?: string;
  className?: string;
  container?: boolean;
  containerBorder?: boolean;
  containerHeight?: number;
  icon?: IconTypes;
  message?: string | ReactNode;
  onClick?: () => void;
}

const Layout = styled.div<Partial<EmptyProps>>`
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  height: auto;

  ${({ container }) =>
    container &&
    css`
      flex-grow: 1;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 0 ${toRem(theme.layout.gutter.large)};
    `}

  ${({ container, containerHeight }) =>
    container &&
    containerHeight &&
    css`
      height: ${toRem(containerHeight)};
    `}

  ${({ containerBorder }) =>
    containerBorder &&
    css`
      border-radius: ${toRem(5.5)};
      border: ${toRem(1)} solid ${theme.color.neutral[200]};
    `}
`;

const StyledIcon = styled(Icon)`
  width: ${toRem(55)};
  height: ${toRem(55)};
  fill: ${theme.color.neutral[400]};
`;

const Message = styled.p<Partial<EmptyProps>>`
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(13.75)};
  line-height: 125%;
  text-align: center;
  color: ${theme.color.neutral[400]};

  ${({ icon }) =>
    icon &&
    css`
      margin-top: ${toRem(8.75)};
    `}
`;

const StyledButton = styled(Button)`
  margin-top: ${toRem(11)};
`;

const Empty: React.FC<EmptyProps> = ({ buttonLabel, className, container = false, containerBorder = false, containerHeight, icon, message, onClick }) => (
  <Layout className={className} container={container} containerBorder={containerBorder} containerHeight={containerHeight}>
    {icon && <StyledIcon icon={icon} />}
    {message && <Message icon={icon}>{message}</Message>}
    {buttonLabel && <StyledButton label={buttonLabel} appearance="secondary" size="small" onClick={onClick} />}
  </Layout>
);

export default Empty;
